// extracted by mini-css-extract-plugin
export default {"lightbulb":"Lightbulb_lightbulb__j4Z9c","innerContainer":"Lightbulb_innerContainer__ayHKe","on":"Lightbulb_on__Ch867"};